import { useMutation } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { MarkOrganizationNotificationDocument } from '~/graphql/generated/graphql';
import { followupMessageErrorState } from '~/state/layouts/SharedAppShell/atoms';
import { patientDetailDialogMessageState } from '~/state/partials/patient_detail_dialog/atoms';

export const useMarkNotification = () => {
  const { selectedMessageId } = useAtomValue(patientDetailDialogMessageState);
  const [markNotification] = useMutation(MarkOrganizationNotificationDocument);
  const { notifications } = useAtomValue(followupMessageErrorState);

  useEffect(() => {
    const notification = notifications.find((n) => n.followupMessage.id === selectedMessageId);
    if (notification) {
      markNotification({
        variables: {
          input: {
            organizationNotificationId: notification.organizationNotificationId,
          },
        },
      });
    }
  }, [selectedMessageId, markNotification, notifications]);
};
